// After page load, check for external links and add target="_blank" to them

// Get all links on the page
const links = document.querySelectorAll('a');

// Loop through each link
links.forEach(link => {
    // Check if the link is external
    if (link.href.startsWith('http') && !link.href.startsWith(window.location.origin)) {
        // Add target="_blank" to the link
        link.target = '_blank';
    }
});
